<mat-list>
    <mat-list-item *ngFor="let item of items" (click)="dismiss(item)" style="margin-top: 0.5rem; margin-bottom: 0.5rem; border-bottom: 1px solid lightgray;">
        <div fxLayout="column" fxLayoutGap="5px">
            <label>{{item.label}}</label>
            <label style="font-size: 12px;">{{item.order.label}}</label>
        </div>
    </mat-list-item>
</mat-list>
